import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./About.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import {
  FaCertificate,
  FaGem,
  FaShippingFast,
  FaCreditCard,
} from "react-icons/fa";
import iso from "../../assets/images/iso.png";
import qra from "../../assets/images/qra.jpg";
import uk from "../../assets/images/uk.jpg";
import msme from "../../assets/images/msme.png";
import FAQSection from "../About/FAQSection";
import { FaHandsHelping, FaLandmark, FaLeaf, FaSun } from "react-icons/fa";
import { FaCalculator, FaArrowRight } from "react-icons/fa";
import certificate from "../../assets/images/certificate.jpg";
import { Helmet } from "react-helmet-async";
const philosophyData = [
  {
    icon: <FaGem />,
    title: "Authenticity First",
    desc: "We strive to source high-quality spiritual and astrological products from trusted suppliers.",
  },
  {
    icon: <FaHandsHelping />,
    title: " Knowledge-Driven Guidance",
    desc: "We aim to provide thoughtful guidance rather than one-size-fits-all suggestions.",
  },
  {
    icon: <FaLandmark />,
    title: "Personalized Approach",
    desc: "We understand that no single remedy is suitable for everyone, so we recommend products.",
  },
  {
    icon: <FaLeaf />,
    title: "Quality You Can Rely On",
    desc: "Each product is selected with attention to quality and presentation.",
  },
  {
    icon: <FaSun />,
    title: "Transparency and integrity ",
    desc: "We value honest communication. We explain our recommendations clearly.",
  },
];
const storyCards = [
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_000000007b7481f59ed47991d07156ba_ef7rve.png",
    title: "Rudrakshas",
    link: "/shop/rudrakshas",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000b8f0820abdd8c9f4a91a11b1_fdknyh.png",
    title: "Shivling",
    link: "/shop/shivling",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_00000000ce5882119c88c3b84f017345_r9tl9s.png",
    title: "Shaligram",
    link: "/shop/shaligram",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000f7b481f489dd24f231401967_er5k9d.png",
    title: "Shankh & Sea Shells",
    link: "/shop/shankh-sea-shells",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_000000008e20820a817b81719ad0fcdb_yxwxrg.png",
    title: "Gemstones",
    link: "/shop/gemstones",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000aec481f48d3a5b50b313cb4b_zksmqo.png",
    title: "Crystals & Healing Stones",
    link: "/shop/crystals",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000027881f4973e7d1c76420d49_w0ag61.png",
    title: "Vastu Shashtra Products",
    link: "/shop/vastu-products",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_000000000b74820a933ba9802cd563a1_pqacpp.png",
    title: "Pooja Essentials",
    link: "/shop/pooja",
  },
  {
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_000000009374820a865fba6dedb257aa_izvkl3.png",
    title: "Perfumes",
    link: "/shop/perfumes",
  },
];
const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "About Astro Logical Solutions",
  url: "https://astrologicalsolutions.in/About",
  description:
    "Discover Astro Logical Solutions for Vedic astrology, numerology, Vastu, spiritual guidance and trusted products for a balanced lifestyle and mindful living.",
  isPartOf: {
    "@type": "WebSite",
    name: "Astro Logical Solutions",
    url: "https://astrologicalsolutions.in/",
  },
};
function About() {
  return (
    <>
      <Helmet>
        <title>
          About Astro Logical Solutions | Vedic & Spiritual Guidance
        </title>

        <meta
          name="description"
          content="Discover Astro Logical Solutions for Vedic astrology, numerology, Vastu, spiritual guidance and trusted products for a balanced lifestyle and mindful living."
        />

        <link rel="canonical" href="https://astrologicalsolutions.in/About" />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="About Astro Logical Solutions | Vedic & Spiritual Guidance"
        />

        <meta
          property="og:description"
          content="Discover Astro Logical Solutions for Vedic astrology, numerology, Vastu, spiritual guidance and trusted products for a balanced lifestyle and mindful living."
        />

        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/About"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Astro Logical Solutions" />

        <meta
          property="og:image"
          content="https://astrologicalsolutions.in/og/about-astro-logical-solutions.jpg"
        />

        <meta name="twitter:card" content="summary_large_image" />

        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
      </Helmet>
      <Header />
      <section className="contact-bannerd">
        <div className="banner-overlayd"></div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span>/</span>
        <span className="active">About Us</span>
      </div>
      <section className="pwStorySection">
        <div className="pwStoryContainer">
          <div className="pwStoryLeft">
            <div className="pwHeading">
              <h2>
                Creating Timeless Products Infused with Purpose, Energy & Sacred
                Wisdom
              </h2>
            </div>
            <p>
              In a world driven by mass production and fleeting trends, we pause
              to create what lasts. We believe that what you surround yourself
              with defines your frequency. Our products are carefully curated
              catalysts of prosperity, heritage, and balance. When you choose
              us, you don't just buy a product you claim a piece of aligned
              luxury, rooted in sacred wisdom and crafted for modern excellence.
              <br />
              <br /> We do not just create products; we manifest energy. Every
              creation is an intersection of timeless wisdom, pristine material,
              and conscious intent designed not just to be used, but to be
              experienced.
            </p>
          </div>
          <div className="pwStoryRight">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={18}
              slidesPerView={3}
              loop={storyCards.length > 3}
              navigation={true}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                992: {
                  slidesPerView: 2,
                  spaceBetween: 18,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 18,
                },
              }}
            >
            {storyCards.map((item, index) => (
  <SwiperSlide key={item.id ?? index}>
    <Link to={item.link} className="pwStoryLink">
      <div className="pwStoryCard">
        <div className="pwStoryImg">
          <img
            src={item.image}
            alt={item.title}
            loading="lazy"
          />
        </div>

        <h4>{item.title}</h4>
      </div>
    </Link>
  </SwiperSlide>
))}
            </Swiper>
          </div>
        </div>
      </section>
      <section className="philosophy-section">
        <div className="philosophy-overlay"></div>

        <div className="philosophy-container">
          <h2 className="philosophy-heading"> What Makes Us Different?</h2>
          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>
          <div className="philosophy-grid">
            {philosophyData.map((item, index) => (
              <div className="philosophy-card" key={index}>
                <div className="philosophy-icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="trustSection">
        <div className="trustContainer">
          <div className="trustBox">
            <h2> Why Choose AstroLogical Solutions™?</h2>

            <ul className="whyList">
              <li>✔️ Integrated Astrology, Numerology & Vastu Solutions</li>
              <li>✔️ Personalized Consultations</li>
              <li>✔️ Curated Spiritual Products</li>
              <li>✔️ Educational & Research-Based Content</li>
              <li>✔️ Customer-First Service</li>
              <li>✔️ Secure Shopping Experience</li>
              <li>✔️ Quality-Focused Product Selection</li>
            </ul>
          </div>

          <div className="trustBox certificateBox">
            <h2>Our Certification</h2>

            <img
              src={certificate}
              alt="ISO Certificate"
              className="certificateImg"
            />
          </div>

          {/* Right */}
          <div className="trustBox founderBox">
            <h2>Founder's Message</h2>
            <div className="founderContent">
              <div className="founderText">
                <p>
                  A good doctor treats the symptoms. A great doctor diagnoses
                  the disease and cures the root cause." ...
                  <b> Maneish RK Sharma</b>
                  ​The very similar process is required while aligning & shaping
                  your life through ancient occult science. But, ​Most people
                  seek superficial and immidiate fixes for deep-seated energetic
                  blockages. They change a name spelling, pick a generic mobile
                  number based on basic numerology, or rearrange furniture
                  blindly and expect immidiate results. But without aligning
                  these shifts with your unique horoscopic blueprint, it is
                  nothing more than hit-and-trial. Because, each individual have
                  unique horoscope, just like our fingerprints are. Answer
                  yourself... Would you take a random prescription without a
                  proper diagnosis and blood test?
                  <br />* If yes you can continue the way you are going in your
                  life.
                  <br />* But if your answer is no then you should not alter
                  your life's vibrations without a precise diagnostic chart
                  (Astro-Logical™) Analysis. At Astro-Logical Solutions, we
                  don't just guess, instead we engineer your informations
                  logically to draw the optimum result oriented solutions.{" "}
                </p>

                <h4>Maneish RK Sharma</h4>

                <span>Founder</span>

                <p className="address">
                  Shiva Aangan, Bachan Singh Colony,
                  <br />
                  Lane No. 9,
                  <br />
                  Muzaffarnagar, Uttar Pradesh - 251001
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="top-marquee">
        <div className="marquee-track">
          {/* First Set */}
          <div className="marquee-content">
            <span>
              <FaCertificate /> Original Certified Products
            </span>
            <span>
              <FaGem /> 92.5 Silver
            </span>
            <span>
              <FaShippingFast /> Free Shipping
            </span>
            <span>
              <FaCreditCard /> Secure Payment
            </span>

            <span>
              <FaCertificate /> Original Certified Products
            </span>
            <span>
              <FaShippingFast /> Free Shipping
            </span>
            <span>
              <FaCreditCard /> Secure Payment
            </span>
          </div>

          {/* Duplicate Set */}
          <div className="marquee-content">
            <span>
              <FaCertificate /> Original Certified Products
            </span>
            <span>
              <FaShippingFast /> Free Shipping
            </span>
            <span>
              <FaCreditCard /> Secure Payment
            </span>

            <span>
              <FaCertificate /> Original Certified Products
            </span>
            <span>
              <FaGem /> 92.5 Silver
            </span>
            <span>
              <FaShippingFast /> Free Shipping
            </span>
            <span>
              <FaCreditCard /> Secure Payment
            </span>
          </div>
        </div>
      </section>
      <section class="why-choose">
        <div class="heading">
          <div className="heading-wrapper">
            <h2>
              The Three Pillars of Our Products{" "}
              <div className="about-heading-line">
                <img
                  src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                  alt="Heading decoration"
                />
              </div>
            </h2>
          </div>
          <br />
          <p>
            Our philosophy rests on three key pillars that make every product of
            ours distinct and ultra-premium in the market:
          </p>

          <div class="top-tags">
            <span>✨ Conscious Material Integrity</span>
            <span>🕉️ Intentional Vibrational Craftsmanship</span>
            <span>❤️ Timeless Heritage Meets Modern Utility</span>
          </div>
        </div>

        <div class="banner">
          <div class="cards">
            <div class="card">
              <h3>
                Conscious Material Integrity (<b>Purity</b>)
              </h3>
              <p>
                The material for every product whether it is metal, a coin,
                fabric, or design elements is selected in its purest form. No
                compromises, no shortcuts.
              </p>
            </div>

            <div class="card">
              <h3>
                Intentional Vibrational Craftsmanship (<b>Energy</b>)
              </h3>
              <p>
                Our products are not merely the result of standard
                manufacturing. During the design process, careful attention is
                paid to vibrational frequency, geometry, and cosmic alignment.
              </p>
            </div>

            <div class="card">
              <h3>
                Timeless Heritage Meets Modern Utility (<b>Culture</b>)
              </h3>
              <p>
                We blend authentic ancient wisdom and heritage with the modern
                lifestyle, creating products that are both functional and
                aesthetically elite.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="whyChoose">
        <div className="container">
          <div className="why-grid">
            {/* Left */}
            <div className="why-left">
              <h2 className="why-title">
                Where Spiritual Wisdom Meets Authenticity
              </h2>

              <div className="line"></div>

              <div className="left-content">
                {/* <h3>Authenticity Guaranteed</h3> */}

                <img src={iso} alt="ISO" />
                <img src={qra} alt="ISO" />

                <img src={uk} alt="ISO" />
                <img src={msme} alt="ISO" />
              </div>
            </div>

            {/* Right */}
            <div className="why-right">
              <p>
                <strong>Astro Logical Solutions</strong> brings together ancient
                spiritual wisdom with trusted quality, offering a complete range
                of authentic spiritual products under one roof. Whether you are
                seeking Rudrakshas, Gemstones, Healing Crystals, Vastu Remedies,
                Tulsi Products, Yantras, or Pooja Essentials, every product is
                carefully selected to meet the highest standards of authenticity
                and craftsmanship.
              </p>

              <p>
                Supported by expert guidance, secure shopping, fast delivery,
                and a customer-first approach, we are committed to helping
                individuals and families create harmony, positivity, protection,
                and spiritual well-being through genuine spiritual solutions.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="our-approach">
        <div className="heading-wrapper">
          <h2>How We Work At Astro-Logical Solutions™ </h2>
          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>
        </div>
        <br />
        <br />
        <p>
          <strong>1. Advanced Cosmic Diagnosis:- </strong>
          Our panel of numerologusts map your life by the deep analysis of your
          chart, the exact planet, number frequency or environmental direction
          causing friction and hurdals in your life.
        </p>

        <p>
          We do deep scanning of the stagnant career, the fractured
          relationship, the chronic health issue to locate the exect root cause,
          within your birth chart.
        </p>

        <p>
          <strong>2. Radical Neutralization:- </strong>
          Once the source of friction is identified, we deploy highly targeted
          energetic tools. Whether through a hyper-customized horoscope-aligned
          mobile number or precise structural Vastu remedies, we neutralize
          negative planetary transits and environmental stressor to shield you.
        </p>

        <p>
          <strong>3. Precision Activation:- </strong>
          We do not just defend; we conquer. We strategically activate the right
          planets in the right houses of your Kundli, unlock the dormant
          frequencies in your numerology grid, and harness the elemental
          directions of your space through object remedies, puja anushthans,
          daan etc. This shifts you from a state of passive endurance to
          absolute cosmic command by rectifying your previous karmik patterns.
        </p>

        <p>
          The universe operates on absolute laws, not chance. Stop treating the
          symptoms of a mis-aligned life. Decode your blueprint, command your
          timing, and own your destiny.
        </p>
      </section>
      <section className="about-difference-section">
        <div className="about-difference-container">
          <div className="about-difference-header">
            <h2>
              How Astro-Logical Solutions™
              <span> is Different?</span>
              <div className="about-heading-line">
                <img
                  src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                  alt="Heading decoration"
                />
              </div>
            </h2>
            <br />
            <div className="about-heading-line"></div>

            <p>
              In today's digital world, finding genuine astrological guidance
              and authentic spiritual products can be overwhelming. At{" "}
              <strong> AstroLogical Solutions™</strong>, our goal is to bring
              together Astrology, Numerology, Vastu, and Spiritual Remedies
              under one trusted platform, making it easier for you to access
              expert guidance and carefully selected products in one place.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>A Complete Astrology &amp; Spiritual Solutions Platform</h3>

            <p>
              Unlike stores that only sell products or consultants who only
              offer advice, <strong>AstroLogical Solutions™</strong> combines
              expert consultations with a curated collection of spiritual
              products. Whether you're seeking guidance for career,
              relationships, health, business, finances, or spiritual growth,
              you can find both personalized recommendations and relevant
              products through a single platform.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Personalized Recommendations</h3>

            <p>
              We understand that every individual has unique goals and
              circumstances. Rather than promoting the same solution to
              everyone, we aim to recommend remedies, products, and
              consultations based on your specific requirements and the
              information you choose to share.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Carefully Curated Spiritual Products</h3>

            <p>Our collection includes a wide range of products such as:</p>

            <div className="product-list">
              <div className="product-list-item">
                <span>✦</span>
                Rudraksha
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Gemstones
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Healing Crystals
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Shivlings
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Shankh &amp; Shaligrams
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Tulsi Wood Products
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Vastu Products
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Pooja Essentials
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Yantras
              </div>

              <div className="product-list-item">
                <span>✦</span>
                Numerology Solutions
              </div>
            </div>

            <p>
              Each product category is selected to align with our focus on
              quality, authenticity, and customer satisfaction.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Education Before Selling</h3>
            <p>
              We believe informed customers make better decisions. That's why we
              regularly share educational content about Astrology, Numerology,
              Vastu, Rudraksha, Gemstones, Crystals, and other spiritual
              subjects. Our aim is to help you understand the purpose,
              significance, and proper use of products before making a purchase.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Transparent &amp; Ethical Approach</h3>

            <p>
              We value honesty and transparency in every interaction. We explain
              our products and services clearly and encourage customers to make
              informed decisions. We avoid unrealistic guarantees and focus on
              providing responsible guidance and quality service.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Customer-Centric Experience</h3>

            <p>
              From consultation and product selection to secure packaging and
              after-sales support, every step is designed to provide a smooth
              and reliable customer experience. Building long-term trust is at
              the heart of everything we do.
            </p>
          </div>
          <div className="difference-content-block">
            <h3>Continuously Growing Product Collection</h3>

            <p>
              We regularly expand our collection by adding carefully selected
              products and services that support the diverse needs of our
              customers, while maintaining our commitment to quality and
              authenticity.
            </p>
          </div>
        </div>
      </section>
      <section className="spiritual-calculators">
        <div className="spiritual-calculators__container">
          <div className="spiritual-calculators__heading">
            <span className="spiritual-calculators__eyebrow">
              ✦ DISCOVER YOUR SPIRITUAL PATH ✦
            </span>

            <h2>Explore Our Spiritual Calculators</h2>

            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Decorative divider"
              />
            </div>

            <p>
              Ancient wisdom, meaningful numbers, and personalized spiritual
              insights begin your journey of discovery.
            </p>
          </div>

      <div className="spiritual-calculators__slider">
  <div className="spiritual-calculators__grid">

<article className="spiritual-calculator-card rudraksha-calculator">
  <div className="spiritual-calculator-card__top">
    <div className="spiritual-calculator-card__icon">
      <FaGem />
    </div>
    <span className="spiritual-calculator-card__number">01</span>
  </div>

  <span className="spiritual-calculator-card__tag">
    SACRED BEAD DISCOVERY
  </span>

  <h3>Rudraksha Calculator</h3>

  <p>
    Explore traditional Rudraksha guidance based on your
    birth details and discover its spiritual significance.
  </p>

  <a
    href="https://astrologicalsolutions.in/rudraksha-calculator"
    className="spiritual-calculator-card__button"
  >
    Explore Rudraksha <FaArrowRight />
  </a>

  <span className="spiritual-calculator-card__watermark">
    ॐ
  </span>
</article>

<article className="spiritual-calculator-card numerology-calculator">
  <div className="spiritual-calculator-card__top">
    <div className="spiritual-calculator-card__icon">
      <FaCalculator />
    </div>
    <span className="spiritual-calculator-card__number">02</span>
  </div>

  <span className="spiritual-calculator-card__tag">
    THE POWER OF NUMBERS
  </span>

  <h3>Numerology Calculator</h3>

  <p>
    Discover traditional numerology interpretations connected
    with your birth date and personal numbers.
  </p>

  <a
    href="https://astrologicalsolutions.in/mobile-numerology"
    className="spiritual-calculator-card__button"
  >
    Calculate Your Numbers <FaArrowRight />
  </a>

  <span className="spiritual-calculator-card__watermark">
    108
  </span>
</article>

  </div>
</div>
        </div>
      </section>
      <FAQSection />
      <Footer />
    </>
  );
}
export default About;
